import React, { useState, useRef, useEffect } from "react";
import { MoreOutlined } from "@ant-design/icons";
import styles from "./ActionAccountMenu.module.scss";

export const AccountActionMenu = ({
  record,
  onEdit,
  onResetPassword,
  onLock,
  onUnlock,
  onDisable,
  canUpdate,
  canResetPassword,
  canLock,
  canDelete,
}) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const [menuStyle, setMenuStyle] = useState({});

  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target) && !buttonRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    requestAnimationFrame(() => {
      if (buttonRef.current) {
        const rect = buttonRef.current.getBoundingClientRect();
        setMenuStyle({
          top: rect.bottom + 6,
          right: window.innerWidth - rect.right,
        });
      }
    });

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  const ACTIONS = [
    {
      key: "edit",
      label: "Chỉnh sửa",
      onClick: onEdit,
      allow: () => canUpdate,
    },
    {
      key: "reset",
      label: "Đặt lại mật khẩu",
      onClick: onResetPassword,
      allow: () => canResetPassword,
    },
    {
      key: "lock",
      label: "Khóa tài khoản",
      onClick: onLock,
      allow: (status) => canLock && status !== "DELETED" && status !== "DISABLED",
    },
    {
      key: "unlock",
      label: "Mở tài khoản",
      onClick: onUnlock,
      allow: (status) => canLock && status === "DISABLED",
    },
    {
      key: "disable",
      label: "Vô hiệu hóa",
      onClick: onDisable,
      allow: (status) => canDelete && status !== "DELETED",
    },
  ];

  const actions = ACTIONS.filter((a) => a.allow(record?.status));

  // If no actions are available, don't render anything
  if (actions.length === 0) {
    return null;
  }

  return (
    <>
      <span
        ref={buttonRef}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((v) => !v);
        }}
      >
        <MoreOutlined className={styles.button} />
      </span>

      {open && (
        <div ref={menuRef} className={styles.menu} style={menuStyle}>
          {actions.map(({ key, label, onClick }) => (
            <div
              key={key}
              className={styles.menuItem}
              onClick={(e) => {
                e.stopPropagation();
                setOpen(false);
                onClick?.(record);
              }}
            >
              {label}
            </div>
          ))}
        </div>
      )}
    </>
  );
};
